import { ITableColumn } from '@/components/UI/DataTable/TableHead'
import { IPrimaryIncome } from '@/types'
import { formatDate } from '@/utils/common'
import { cell } from '../cell'
import { formatDay, formatDollars, formatEnum, primaryPayDay } from '../format'

const dateTime = (value?: string | null) => (value ? formatDate(value, false, true) : '')

export const primaryIncomeColumns: ITableColumn<IPrimaryIncome>[] = [
  {
    key: 'description',
    id: 'description',
    label: 'Description',
    minWidth: '200px',
    render: (_v, r) => cell(r.description),
  },
  {
    key: 'amount',
    id: 'amount',
    label: 'Amount',
    align: 'right',
    render: (_v, r) => cell(formatDollars(r.amount)),
  },
  {
    key: 'payType',
    id: 'payType',
    label: 'Pay Type',
    render: (_v, r) => cell(formatEnum(r.payType)),
  },
  {
    key: 'recurringFrequency',
    id: 'recurringFrequency',
    label: 'Frequency',
    render: (_v, r) => cell(formatEnum(r.recurringFrequency)),
  },
  { key: 'payDay', id: 'payDay', label: 'Pay Day', render: (_v, r) => cell(primaryPayDay(r)) },
  {
    key: 'payCycleScore',
    id: 'payCycleScore',
    label: 'Pay Cycle Score',
    render: (_v, r) => cell(r.payCycleScore.toFixed(2)),
  },
  {
    key: 'startDate',
    id: 'startDate',
    label: 'Start Date',
    minWidth: '120px',
    render: (_v, r) => cell(formatDay(r.startDate)),
  },
  {
    key: 'suggestedStartDate',
    id: 'suggestedStartDate',
    label: 'Suggested Start',
    minWidth: '120px',
    render: (_v, r) => cell(formatDay(r.suggestedStartDate)),
  },
  {
    key: 'createdAt',
    id: 'createdAt',
    label: 'Created At',
    minWidth: '170px',
    render: (_v, r) => cell(dateTime(r.createdAt)),
  },
  {
    key: 'updatedAt',
    id: 'updatedAt',
    label: 'Updated At',
    minWidth: '170px',
    render: (_v, r) => cell(dateTime(r.updatedAt)),
  },
]
